import { RHFExtras } from '@common/components/SpaEntity/components/RHFExtras';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { ConfigurationGroupType } from 'shared-types/SpaPackage';
import { SpaPackageFormValues } from '../../SpaPackageForm.schema';
import { adaptExtras } from './utils';

type SpaPackageExtrasProps = {
  extras: ConfigurationGroupType[];
};

export const SpaPackageExtras: FC<SpaPackageExtrasProps> = ({ extras }) => {
  const { control } = useFormContext<SpaPackageFormValues>();
  const guests = useWatch({ control, name: 'guests' });
  const watchedExtras = useWatch({ control, name: 'extras' });

  const selectedGuests = (guests || []).map(
    ({ title, firstName, lastName, gender, id, loggedInUser }: any) => ({
      title,
      firstName,
      lastName,
      gender,
      ...(id && id !== loggedInUser?.id && { id }),
      loggedInUser,
    })
  );

  const adaptedExtras = adaptExtras(extras);

  return (
    <RHFExtras
      extras={adaptedExtras}
      selectedGuests={selectedGuests}
      showPrice
      selectedExtras={watchedExtras as any}
      fieldPrefix="extras"
    />
  );
};
